import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import {
  // ReactDateTimePicker,
  Select,
} from '../../../components/elements';
import LocationSuggestion from '../../../components/global/LocationSuggestion';
import AssignPlaces from '../TableBookingSettingsListings/AssignPlaces';
import DateFilter from './DateFilter';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const filterOptions = [
  { value: 'FILTER BY DAY', label: 'FILTER BY DAY' },
  { value: 'FILTER BY MONTH', label: 'FILTER BY MONTH' },
  { value: 'FILTER BY WEEK', label: 'FILTER BY WEEK' },
];

const Search = ({
  placeName,
  city,
  // startDate,
  // endDate,
  // bookingDateFilter,
  dateFilterDisabled,
  handleChange,
  setStartDateRef,
  setEndDateRef,
}) => {
  const [filterBy, setFilterBy] = React.useState({
    value: 'FILTER BY DAY',
    label: 'FILTER BY DAY',
  });

  return (
    <Wrapper>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-3">
            <AssignPlaces
              onChange={id => {
                handleChange({ placeFilter: id });
              }}
              placeId={placeName}
              key={placeName}
            />
          </div>
          {dateFilterDisabled ? (
            <div className="column mt-5">
              <button
                type="button"
                className="button is-primary"
                onClick={() =>
                  handleChange({
                    dateFilterDisabled: false,
                  })
                }
              >
                Add Date Filter
              </button>
            </div>
          ) : (
            <>
              <div
                className="column"
                style={{ position: 'relative', top: '20px' }}
              >
                <Select
                  options={filterOptions}
                  value={filterBy}
                  onChange={({ value }) => {
                    setFilterBy(filterOptions.find(ele => ele.value === value));
                  }}
                />
              </div>
              <div
                className="column"
                style={{ position: 'relative', top: '20px' }}
              >
                <DateFilter
                  filterType={filterBy}
                  setStartDate={date => {
                    setStartDateRef(date);
                  }}
                  setEndDate={date => {
                    setEndDateRef(date);
                  }}
                />
              </div>
              {!dateFilterDisabled && (
                <div className="column mt-5">
                  <button
                    type="button"
                    className="button is-primary"
                    onClick={() => {
                      handleChange({
                        dateFilterDisabled: true,
                      });
                      setStartDateRef('');
                      setEndDateRef('');
                    }}
                  >
                    Remove Date Filter
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        <div className="columns">
          <div className="column is-3">
            <div className="field">
              <label className="label">City / Suburb</label>
              <div className="control">
                <LocationSuggestion
                  initialValue={city || ''}
                  onSelect={value => {
                    handleChange({
                      cityFilter: value.name,
                    });
                  }}
                  onHandleClear={() =>
                    handleChange({
                      cityFilter: '',
                    })
                  }
                  placeholder="Start entering company name..."
                />
              </div>
            </div>
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default withRouter(Search);
